export const LOGIN = "login";
export const LOGOUT = "logout";
export const REGISTER = "register";
export const UPDATE_USER = "updateUser";
export const DATA_USER = "dataUser";
export const CREATE_USER = "createUser";
export const FETCH_USERS = "fetchUsers";
export const GET_BALANCE = "getBalance";
export const CHANGE_PASSWORD = "changePassword";
export const RECOVER_PASSWORD = "recoverPassword";
export const RESTORE_PASSWORD = "restorePassword";
export const GENERATE_2FA_TOKEN = "fetch2faToken";
export const VERIFY_2FA_TOKEN = "verify2faToken";

export const CHECK_AUTH = "checkAuth";
export const FETCH_LASTTRANSACTIONS = "lastTransactions";
export const FETCH_PROFILE = "profile";
export const FETCH_COMPANIES = "fetchCompanies";
export const CREATE_COMPANY = "createCompany";

export const FETCH_CARRIERS = "fetchCarriers";
export const FETCH_BANKS = "fetchBanks";
export const FETCH_BANKUSERS = "fetchBankUsers";
export const UPDATE_BANKUSERS = "updateBankUsers";
export const FETCH_ROLS = "fetchRols";

export const REQUEST_BUY = "requestBuy";
export const FETCH_BUYS = "fetchBuys";
export const FETCH_ADMINBUYS = "fetchAdminBuys";
export const PROCESS_BUYS = "processBuys";
export const PAY_DEBT = "payDebts";
export const FETCH_BALANCEBANKS = "fetchBalanceBanks";
export const FETCH_RESUMEN = "fetchResumen";

export const FETCH_ADMINCONSIGNMENTS = "fetchAdminConsignments";
export const REQUEST_CONSIGNMENTMANUAL = "requestConsignmentManual";
export const FETCH_CONSIGNMENTS = "fetchConsignments";
export const REPORT_CONSIGNMENT = "reportConsignments";
export const PROCESS_CONSIGNMENTS = "processConsignmnets";
export const REVERSE_CONSIGNMENTS = "reverseConsignmnets";
export const UPLOAD_FILE = "uploadFile";
